import { useState } from "react";

import { Checkbox } from "@newsela/angelou";
import PropTypes from "prop-types";

import { withTrackEvent, actionNames, objectTypes } from "@newsela/snitch";
import { checkBoxLabelCss } from "./ReadAloudSetting.style";

const CheckboxWithTrackEvent = withTrackEvent(Checkbox);

const propTypes = {
  assignmentId: PropTypes.string,
  currentContentLevel: PropTypes.object,
  isReadAloudHidden: PropTypes.bool,
  onHideReadAloudChange: PropTypes.func,
};

const ReadAloudSetting = ({
  assignmentId,
  currentContentLevel,
  isReadAloudHidden,
  onHideReadAloudChange,
}) => {
  const [isHideReadAloudChecked, setIsHideReadAloudChecked] =
    useState(!isReadAloudHidden);

  const eventProperties = {
    objectType: objectTypes.assignment,
    actionName: actionNames.update,
    streamProperties: {
      content_type: "Article",
      content_id: currentContentLevel?.id,
      content_ids: [currentContentLevel?.header_id],
      description: `Toggle students can listen to the article ${isReadAloudHidden ? "on" : "off"}`,
      object_id: assignmentId,
    },
  };

  return (
    <CheckboxWithTrackEvent
      __cssFor={{ root: checkBoxLabelCss(isHideReadAloudChecked) }}
      checked={isHideReadAloudChecked}
      label="Students can listen to the article"
      name="Students can listen to the article"
      dataProps={{
        "data-qa-selector": `students_can_listen_to_article_${isReadAloudHidden ? "on" : "off"}`,
      }}
      onClick={() => {
        setIsHideReadAloudChecked(
          (prevIsHideReadAloudChecked) => !prevIsHideReadAloudChecked,
        );
        onHideReadAloudChange(!isReadAloudHidden);
      }}
      {...eventProperties}
    />
  );
};

ReadAloudSetting.propTypes = propTypes;

export default ReadAloudSetting;
